const shared = require('./shared');

const config = {
  MONGO_URI: `mongodb://localhost/${shared.name}-local`,
  PORT: 3055
};

module.exports = Object.assign(shared, config);
